import { MenuOutlined } from "@ant-design/icons"
import { COLOR } from "@finway-group/shared/lib/consts/colors"
import { CsvTemplateSelectedField } from "@finway-group/shared/lib/models"
import { Empty, Row, Table } from "antd"
import Input from "antd/lib/input/Input"
import { ColumnsType } from "antd/lib/table"
import React, { RefObject, useRef } from "react"
import { useTranslation } from "react-i18next"

import { TrashIcon } from "Components/icons/TrashIcon"
import { SearchIcon } from "Components/icons/SearchIcon"
import { HandleDragEndParams, useDraggableTable } from "Shared/hooks/table.hooks"

import { DraggableRow } from "./draggableRow"
import DraggableTableWrapper from "./draggableTableWrapper"

interface SelectedCsvHeadersTableInterface {
    data?: Array<CsvTemplateSelectedField>
    onChangeArray: (arg: Array<CsvTemplateSelectedField>) => void
    onDeleteItem: (arg: CsvTemplateSelectedField) => void
}

const SelectedCsvHeadersTable: React.FC<SelectedCsvHeadersTableInterface> = ({ data = [], onChangeArray, onDeleteItem }) => {
    const dragAndDropAnchor = useRef(null)

    const { t } = useTranslation()

    const handleDragEnd = ({ newList }: HandleDragEndParams<CsvTemplateSelectedField>) => {
        onChangeArray(newList)
    }

    const { dataSource, onDragEnd, onDragStart, activeId } = useDraggableTable({ dataSource: data, handleDragEnd })

    const refMap: Array<RefObject<HTMLTableRowElement>> = []

    const search = (e: any) => {
        const term = e.target.value.toString().toLocaleLowerCase()
        const index = data.findIndex(({ label }) => label.toLocaleLowerCase().includes(term))
        const ref = refMap[index]
        ref?.current?.scrollIntoView()
    }

    const columns: ColumnsType = [
        {
            title: "Order",
            dataIndex: "label",
            key: "sort",
            className: "header-names-cell",
            render: (label: string) => (
                <Row>
                    <div className="drag-visible-hover" style={{ fontSize: "10px", paddingRight: "10px", alignSelf: "center" }}>
                        <MenuOutlined style={{ cursor: "grab", color: COLOR.gray[900] }} />
                    </div>
                    <span>{label}</span>
                </Row>
            ),
        },
        {
            key: "action",
            title: "action",
            className: "action-visible-hover",
            align: "right",
            render: (selectedFieldToDelete: CsvTemplateSelectedField) => (
                <div
                    style={{ fontSize: "10px" }}
                    onClick={() => {
                        onDeleteItem(selectedFieldToDelete)
                    }}
                >
                    <TrashIcon />
                </div>
            ),
        },
    ]

    if (!data.length) {
        return <Empty />
    }

    return (
        <DraggableTableWrapper onDragEnd={onDragEnd} columns={columns} dataSource={dataSource} activeId={activeId} onDragStart={onDragStart}>
            <div className="selectedHeadersTable">
                <div id="drag-and-drop-anchor" ref={dragAndDropAnchor} className="w-full antd-table" />
                <Table<CsvTemplateSelectedField>
                    title={() => (
                        <Input
                            bordered={true}
                            style={{ fontSize: "small", border: "none" }}
                            prefix={<SearchIcon />}
                            onChange={search}
                            disabled={data.length < 6}
                            allowClear
                            placeholder={t("placeholder:search")}
                            required
                        />
                    )}
                    showHeader={false}
                    columns={columns}
                    pagination={false}
                    dataSource={dataSource}
                    size={"small"}
                    tableLayout="auto"
                    scroll={{ y: 200 }}
                    components={{
                        body: {
                            row: DraggableRow,
                        },
                    }}
                ></Table>
            </div>
        </DraggableTableWrapper>
    )
}

export default SelectedCsvHeadersTable
